import styled from 'styled-components';

export const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: ${props => (props.$isOpen ? 'block' : 'none')};

  @media (width >= 48rem) {
    display: none;
  }
`;

export const Panel = styled.aside<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  height: 100dvh;
  background: var(--white);
  z-index: 101;
  overflow-y: auto;
  padding: var(--spacing-base);
  transform: ${props => (props.$isOpen ? 'translateX(0)' : 'translateX(-100%)')};
  transition: transform 0.3s ease;

  @media (width >= 48rem) {
    position: static;
    transform: none;
    width: 250px;
    height: auto;
    flex-shrink: 0;
    padding: 0;
    padding-right: var(--spacing-base);
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: auto;
  margin-bottom: var(--spacing-small);

  @media (width >= 48rem) {
    display: none;
  }
`;

export const TOOLBAR_ROW_HEIGHT = '55px';

export const InStockSection = styled.div`
  display: flex;
  align-items: center;
  min-height: ${TOOLBAR_ROW_HEIGHT};
  padding: var(--spacing-small) 0;
  border-bottom: 1px solid var(--grey-200);
  box-sizing: border-box;
`;

export const FacetSection = styled.div`
  border-bottom: 1px solid var(--grey-200);
  padding: var(--spacing-small) 0;

  /* #2934 A11Y-15 - facet headings moved h3 -> h2; the page h1 was followed
     directly by h3, skipping a level. */
  & h2 {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-semibold);
    margin-top: var(--spacing-base);
    margin-bottom: var(--spacing-base);
  }

  & ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-small);

    & ul {
      padding: var(--spacing-base) 0 var(--spacing-base) var(--spacing-base);
    }
  }
`;

export const FacetCount = styled.span`
  color: var(--grey-500);
  font-size: var(--font-size-text-sm);
  margin-left: auto;
  padding-right: 4px;
`;

export const CategoryLink = styled.a<{ $isRefined: boolean }>`
  text-decoration: none;
  color: var(--black);
  cursor: pointer;
`;

export const ParentPageLink = styled(CategoryLink)`
  color: var(--brand-900);
  padding-bottom: var(--spacing-base);
  display: block;
`;

export const MobileButtons = styled.div`
  display: flex;
  gap: var(--spacing-small);
  padding-top: var(--spacing-base);

  @media (width >= 48rem) {
    display: none;
  }
`;

export const ApplyButton = styled.button`
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: var(--radius-large);
  background: var(--brand-500);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-text-sm);
  cursor: pointer;
  color: var(--black);
`;

export const ShowMoreButton = styled.button<{ $isExpanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-small);
  width: 100%;
  padding: 10px 0;
  border: none;
  background: var(--white);
  color: var(--brand-900);
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-regular);
  cursor: pointer;
  margin-top: var(--spacing-xsmall);

  & svg {
    width: 18px;
    height: 18px;
    transition: rotate 200ms;
    rotate: ${props => (props.$isExpanded ? '-180deg' : 'none')};
  }

  &:hover {
    color: var(--brand-800);
  }
`;
